export default "__VITE_ASSET__B39SAqV4__"